module.exports = __webpack_public_path__ + "static/media/mpl-logo.cce0b08a.png";